// @ts-ignore
import React from 'react'
import { TradeCalculator } from 'components/Calculators/TradeCalculator'
import { useSearchParams } from 'react-router-dom';
import { useProducts } from 'hooks/useProducts';

export const TradePage = () => {
    // #region HOOKS
    const [searchParams] = useSearchParams();
    const products = useProducts();
    //#endregion

    //#region STATE
    const fromProduct = searchParams.get('fromProduct') as string;
    const toProduct = searchParams.get('toProduct') as string;
    //#endregion

    //#region LIFECYCLE
    //#endregion

    return (
        <div>
            <TradeCalculator amount={0}
                toProduct={toProduct}
                fromProduct={fromProduct}
                toProductType={products?.find((p: any) => p.code === toProduct)?.category}
            />
        </div>
    )
}